import React, { Dispatch, useRef, useCallback, useState } from 'react';

import { Form } from '@unform/web';
import {
  FiMail,
  FiLock,
  FiUser,
  FiArrowRight,
  FiArrowLeft,
} from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useAuth } from '../../../../hooks/Auth';
import Input from '../../../../components/Input';
import MaskedInput from '../../../../components/MaskedInput';
import { useToast } from '../../../../hooks/Toast';
import { AnimatedDiv } from '../../styles';
import { LoginContent } from './styles';
import getValidationErrors from '../../../../utils/getValidationErrors';
import SelectSimple from '../../../../components/SelectSimple';

import Button from '../../../../components/Button';
import { BuyContext } from '../../index';
import api from '../../../../services/api';
import { FaArrowLeft } from 'react-icons/fa';
import TextareaInput from '../../../../components/TextareaInput';

interface ComponentProps {
  step: number[];
  setStep: Dispatch<React.SetStateAction<number[]>>;
  buyContext: BuyContext;
  setBuyContext: Dispatch<React.SetStateAction<BuyContext>>;
}

interface SignInData {
  email: string;
  password: string;
}

interface LoginProps {
  name: string;
  email: string;
  password: string;
  company: string;
  phone: string;
  position: string;
  document_type: string;
  document_number:string;
  birth_date: string;
  know_about ?: string;
}

const LoginContainer: React.FC<ComponentProps> = ({
  buyContext,
  setBuyContext,
  setStep,
  step,
}) => {
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const { productType } = buyContext;
  const [buyType, setBuyType] = useState('');

  const handleLogin = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        setBuyContext({ ...buyContext, isLogged: true });

        setStep([3, 4]);
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, buyContext, setBuyContext, setStep],
  );

  const handleNewLogin = useCallback(
    async (data: LoginProps) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
            company: Yup.string().required('Campo Empresa é obrigatório'),
            position: Yup.string().required('Preencha seu Cargo'),
            phone: Yup.string()
            .min(10, 'Telefone deve conter ao menos 10 caracteres')
            .max(11, 'Telefone deve conter no máximo 11 caracteres')
            .required('Telefone obrigatório'),
          password: Yup.string().required('Senha obrigatória'),

          document_number: Yup.string()
            .min(11, 'Preencha a CPF / CNPJ')
            .required('Número do documento obrigatório'),

          birth_date: Yup.string()
            .min(10, 'min 10 Preecha a Data de Nascimento')
            .max(10, 'max 10 Preecha a Data de Nascimento')
            .required('Data de Nascimento obrigatória'),
        });
        data.phone = data.phone.toString().replace(/[^0-9]/g, '');
        data.birth_date.toString()
        .replace(/[^0-9/]/g, '');
        data.document_number.toString()
        .replace(/[^0-9]/g, '');
        await schema.validate(data, { abortEarly: false });

        const { name, email, password, company, phone, position,
          document_number,
know_about,
          birth_date } = data;

        const newUser = await api
          .post('/signup', { name, email, password, company, phone,know_about, position,document_type : 'cpf',
            document_number : document_number.toString()
            .replace(/[^0-9]/g, ''),

            birth_date })
          .catch(error => {

            if (error instanceof Yup.ValidationError) {
              const errors = getValidationErrors(error);
              formRef.current?.setErrors(errors);
            }

            addToast({
              type: 'error',
              title: error.response.data.message,
            });
            return false;
          });

        if (!newUser) {
          return false;
        }
        await signIn({ email, password });
        setBuyContext({ ...buyContext, login: { name, email, password } });
        if (productType === 'free') {
          setStep([3, 6]);
        } else {
          setStep([3, 4]);
        }

        return false;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          console.log(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na validação',
          description: 'Ocorreu um erro ao tentar validar',
        });
      }
    },
    [addToast, buyContext, setBuyContext, setStep, signIn],
  );

  return (
    <AnimatedDiv visible={step[1] === 3}>
      <LoginContent>
        <div>   <aside>
          {buyType === '' &&  (
         <AnimatedDiv visible>
           <h2>Selecione a opção:</h2>
                <div style={{display: 'flex'}}><Button style={{marginRight: '5px'}} onClick={() => setBuyType('new')}>Novo Cadastro</Button>
                <Button onClick={() => setBuyType('login')}>Já tenho cadastro</Button></div>
               </AnimatedDiv>

          )}
        {buyType !== '' && <AnimatedDiv visible>
            <h3 style={{display:'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}} onClick={() => setBuyType('')}><FaArrowLeft/> Voltar</h3>


          {buyType === 'login' &&   <Form ref={formRef} onSubmit={handleLogin}>

         <h1>Login</h1>
<Input icon={FiMail} name="email" placeholder="E-mail" />
<Input
  icon={FiLock}
  name="password"
  type="password"
  placeholder="senha"
/>
<Button type="submit">Entrar</Button>
<Link style={{color: '#fff'}} to="/recuperar_senha">Esqueci minha senha</Link>
</Form>}

          {buyType === 'new' &&
            <Form ref={formRef} onSubmit={handleNewLogin}>
              <h1>Novo cadastro</h1>

              <Input  name="name" placeholder="Nome completo" />
              <Input  name="email" placeholder="E-mail" />
              <Input  name="company" placeholder="Empresa" />
              <SelectSimple
                  options={[
                    { value: 'TÉCNICO EM RADIOTERAPIA', label: 'TÉCNICO EM RADIOTERAPIA'},
                    { value: 'TECNÓLOGO EM RADIOTERAPIA', label: 'TECNÓLOGO EM RADIOTERAPIA'},
                    { value: 'FÍSICO', label: 'FÍSICO'},
                    { value: 'MÉDICO', label: 'MÉDICO'},
                    { value: 'ENFERMEIRO', label: 'ENFERMEIRO'},
                    { value: 'TÉCNICO DE ENFERMAGEM', label: 'TÉCNICO DE ENFERMAGEM'},
                    { value: 'DENTISTA', label: 'DENTISTA'},
                    { value: 'ASSISTENTE SOCIAL', label: 'ASSISTENTE SOCIAL'},
                    { value: 'NUTRICIONISTA', label: 'NUTRICIONISTA'},
                    { value: 'PSICÓLOGO', label: 'PSICÓLOGO'},
                    { value: 'OUTRO', label: 'OUTRO'},

                  ]}


                  name="position"
                  formRef={formRef}
                  label="Cargo"
                />
              <MaskedInput mask="(99) 99999.9999"  name="phone" placeholder="Telefone" />

            <MaskedInput
              mask={'999.999.999-99'}
              name="document_number"
              placeholder={'CPF'}
            />

            <MaskedInput
              mask="99/99/9999"
              name="birth_date"
              placeholder="Data de aniversário"
            />
              <Input
                icon={FiLock}
                name="password"
                type="password"
                placeholder="senha"
              />

<TextareaInput name="know_about" placeholder="Como soube do evento?" />
              <Button type="submit">
                {productType === 'free' ? 'Finalizar' : 'Continuar'}

                <FiArrowRight />
              </Button>

            </Form>}</AnimatedDiv>}
          </aside>
        </div>
      </LoginContent>
    </AnimatedDiv>
  );
};

export default LoginContainer;
